import React from 'react';
import PauseIcon from '@mui/icons-material/Pause';
import Icon from '../ui-components/Icon';
import { TypedMap } from 'flow/types/TypedMap';
import { Contact } from 'flow/types/Contact';
import ContactAvatar from '../ui-components/ContactAvatar';
import { AvatarSize } from 'flow/components/ui-components/ChatAvatar';
import { twMerge } from 'tailwind-merge';

interface Props {
    contact: TypedMap<Contact>;
    direction: string;
    size: AvatarSize;
    isAccepted: boolean;
    isOnHold: boolean;
    isConference: boolean;
}

const CallAvatar = ({
    contact,
    size,
    direction,
    isAccepted,
    isOnHold,
    isConference,
}: Props) => {
    const avatarDecorator = () => {
        if (isOnHold) {
            return (
                <div className="absolute inset-0 m-auto flex rounded-full bg-black/50">
                    <PauseIcon className="inset-0 m-auto fill-white" />
                </div>
            );
        } else if (direction === 'incoming' && !isAccepted) {
            return (
                <div className="animate-incomingCallPulseLarge border-yellow absolute inset-0 m-auto rounded-full border-2 border-solid" />
            );
        } else {
            return null;
        }
    };

    const sizes = {
        small: 'size-6 text-2xs',
        medium: 'size-9',
        toolbar: 'size-10',
        large: 'size-14 text-lg',
        extraLarge: 'size-20 text-2xl',
        videoLarge: 'size-40 text-3xl',
    };

    return (
        <div className="relative my-2 flex content-center items-center">
            {isConference ? (
                <div
                    className={twMerge(
                        'bg-pbx-conference relative flex items-center justify-center rounded-full font-bold text-white',
                        sizes[size],
                    )}
                >
                    <Icon iconKey={'phone_in_talk'} />
                </div>
            ) : (
                <ContactAvatar contact={contact} size={size} />
            )}
            {avatarDecorator()}
        </div>
    );
};

export default React.memo(CallAvatar);
